<div *ngIf="stock" class="stock" [matTooltip]="'drugs.stock' | translate">
  <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-box-open"></mat-icon> {{ stock.totalRemainingUsages }}
</div>
